module.exports = __webpack_public_path__ + "static/img/5设计师2.a0476e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/5设计师2.png
// module id = lzos
// module chunks = 1